// extracted by mini-css-extract-plugin
module.exports = {"socialMedia":"SocialMediaLinks_socialMedia__3aYHi","socialImage":"SocialMediaLinks_socialImage__1ghiH"};